import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntegrationsModalComponent } from './integrations-modal.component';
import {TpModalModule} from "../../../../components/tp-modal/tp-modal.module";
import {TpButtonModule} from "../../../../components/tp-button/tp-button.module";
import {TranslateModule} from "@ngx-translate/core";
import {IntegrationsPageModule} from "../integrations-page/integrations-page.module";
@NgModule({
    declarations: [
        IntegrationsModalComponent
    ],
    imports: [
        CommonModule,
        TpModalModule,
        TpButtonModule,
        TranslateModule,
        IntegrationsPageModule
    ],
    exports: [
        IntegrationsModalComponent
    ]
})
export class IntegrationsModalModule { }